import * as React from 'react';
import '../css/info-banner.sass';
import Card from './Card';

interface InfoBannerProps {
  headingText?: string;
  children: React.ReactNode;
}

export default function InfoBanner(props: InfoBannerProps) {
  return (
    <div className="infoCard">
      <Card backgroundColor="#F5F5F6">
        <span className="infoImage"></span>
        <div className="infoContent">
          <div>
            <span className="infoHead">{props.headingText}</span>
            {props.children}
          </div>
        </div>
      </Card>
    </div>
  );
}
